var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgLoginHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 635,
    viewBox: "0 0 683 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_218)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 683,
    height: 640,
    fill: "#54C2B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-58.2543 -45L-36.4135 7.28751C-14.5727 59.575 28.6035 165.025 82.3915 252.095C136 337.895 199.895 407.46 295.119 422.76C390.849 437.185 516.898 399.096 609.091 419.647C700.093 440.679 757.418 521.622 785.828 562.532L814.744 602.566L711.153 781.991L672.131 759.461C633.109 736.932 555.066 691.874 477.707 647.211C399.663 602.152 321.62 557.094 243.576 512.035C165.533 466.977 87.4893 421.919 10.1304 377.255C-67.9131 332.197 -145.957 287.139 -184.978 264.609L-224 242.08L-58.2543 -45Z",
    fill: "#61D4C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-435 503.08L-378.797 495.851C-322.595 488.622 -209.684 473.288 -107.385 476.335C-6.27587 479.862 85.9166 500.413 146.779 575.23C207.136 650.922 237.174 779.129 301.069 848.694C364.784 916.989 463.546 926.162 513.179 930.311L562.307 935.336L665.898 755.911L626.877 733.381C587.855 710.852 509.811 665.794 432.452 621.131C354.409 576.072 276.366 531.014 198.322 485.955C120.279 440.897 42.2351 395.838 -35.1238 351.175C-113.167 306.117 -191.211 261.058 -230.232 238.529L-269.254 216L-435 503.08Z",
    fill: "#61D4C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-335 -259.853L-277.414 -267.26C-219.827 -274.667 -104.137 -290.378 0.680227 -287.256C104.278 -283.642 198.74 -262.585 261.101 -185.926C322.944 -108.371 353.722 22.9917 419.189 94.2695C484.473 164.246 585.666 173.645 636.521 177.896L686.859 183.044L793 -0.798059L753.018 -23.8819C713.035 -46.9657 633.07 -93.1334 553.807 -138.896C473.842 -185.064 393.878 -231.231 313.913 -277.399C233.948 -323.567 153.984 -369.734 74.7202 -415.497C-5.24448 -461.665 -85.2092 -507.832 -125.192 -530.916L-165.174 -554L-335 -259.853Z",
    fill: "#61D4C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 683,
    height: 635,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLoginHero);
export default __webpack_public_path__ + "static/media/bg-login-hero.346b9c2e1d0328f190b9f9b014536a41.svg";
export { ForwardRef as ReactComponent };